import React, { FC, useState } from 'react';
import { useLazyDownloadFileQuery, useLazyDownloadVersionQuery } from '../../../api/projectsApi';
import Icon from '../../../components/Icon/Icon';
import { IconSizeE } from '../../../models/enums';

import styles from '../videoPlayer.module.scss';
import { Link } from 'react-router-dom';

type DownloadIconPropTypes = {
    PreviewDownloadUrl: string;
    fileFormat: string;
    AdId: string;
    Id: number;
};

function downloadFile(link: string): void {
    const anchorElement = document.createElement("a");
    anchorElement.href = link;
    anchorElement.setAttribute("download", "");
    anchorElement.style.display = "none";
    document.body.appendChild(anchorElement);
    anchorElement.click();
    document.body.removeChild(anchorElement);
}

const DownloadIcon: FC<DownloadIconPropTypes> = (props) => {
    const { PreviewDownloadUrl, fileFormat, AdId, Id } = props;
    const [downloadVersion] = useLazyDownloadVersionQuery();
    const [isDownloading, setIsDownloading] = useState(false);

    const handleDownload = async () => {
        setIsDownloading(true);
        const { data }: any = await downloadVersion({ PreviewDownloadUrl });
        downloadFile(data)
        // downloadFile(data);
        setIsDownloading(false);
    };

    return PreviewDownloadUrl ? (
        <span
            className={styles.downloadButtonWrapper}
            onClick={handleDownload}
        >
            <span>Download</span>
            <Icon
                name={isDownloading ? 'loading' : 'download'}
                size={IconSizeE.S}
                title='Download the preview video file'
            />
        </span>
    ) :
        <span />
};

export default DownloadIcon;